<template lang="pug">
header.guest-header
  span.guest-header__badge(v-if="icon")
    i(:class="icon" aria-hidden="true")
  h1.guest-header__title {{ title }}
  p.guest-header__subtitle(v-if="subtitle") {{ subtitle }}
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
    icon: String,
  },
};
</script>

<style lang="scss" scoped>
.guest-header {
  @apply mb-6;
  @apply flex;
  @apply flex-col;
  @apply items-center;
  @apply text-center;

  &__badge {
    @apply flex;
    @apply items-center;
    @apply justify-center;
    @apply h-12;
    @apply w-12;
    @apply mb-3;
    @apply rounded-full;
    @apply bg-gignetgreen-200;

    i {
      @apply text-2xl;
      @apply leading-none;
      @apply text-gignetgreen-700;
    }
  }

  &__title {
    @apply text-xl;
    @apply font-semibold;
    @apply text-bluegray-700;
    @apply leading-snug;
  }

  &__subtitle {
    @apply text-sm;
    @apply text-bluegray-400;
    @apply leading-snug;
    @apply mt-1;
  }
}
</style>
